import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './store/store';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

window.addEventListener('beforeunload', (event) => {
  // Your code to handle the event
  // For example, you might want to show a confirmation message
  const confirmationMessage = 'Are you sure you want to leave?';
  event.returnValue = confirmationMessage; // Standard for most browsers
  return confirmationMessage; // For some older browsers
});
